import {Component, OnDestroy, OnInit} from '@angular/core';
import {TranslateService, LangChangeEvent} from '@ngx-translate/core';
import {FaqService} from '../services/faq.service';
import {FaqType} from '../types/faq.type';


@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit, OnDestroy {
  private lang;
  private langSubscription;
  public faqs: Array<any>;
  public emptyFaqData: boolean = false;
  public purpose;

  constructor(public faqService: FaqService,
              private translate: TranslateService) {
    this.lang = translate.currentLang;
    this.langSubscription = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.lang = event.lang;

      this.retrieveData();
    });
    this.faqs = [];
    this.purpose = {
      title: '',
      content: ''
    };
  }

  ngOnInit() {
    this.retrieveData();
  }

  ngOnDestroy() {
    this.langSubscription.unsubscribe();
  }

  retrieveData() {
    this.faqService.getFaqs(this.lang).subscribe((faqData: Array<FaqType>) => {
      this.setFaqData(faqData);
    });
  }

  setFaqData(faqData) {
    this.faqs = [];
    if (faqData.length == 0) {
      this.emptyFaqData = true;
    } else {
      this.purpose = faqData[0];
      this.emptyFaqData = false;

      for (let i = 1; i < faqData.length; i++) {
        let titleHTML = faqData[i].title;
        const titleSentenceStartPosition = 11;
        const titleWithNumbering = titleHTML.slice(0, titleSentenceStartPosition) + i + '.&nbsp;';
        titleHTML = [titleWithNumbering, titleHTML.slice(titleSentenceStartPosition)].join('');

        this.faqs.push({
          question: titleHTML,
          answer: faqData[i].content
        });
      }
    }
  }
}
